$(() => {
    $('[data-datepicker]').each(function () {
        $(this).flatpickr({
            dateFormat: "d.m.Y",
            locale: 'cs'
        });
    })
})